import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Pill from '../../Pill/Pill.js';
import { SAVED_SEARCH_LIST_CATEGORY_KEY, SAVED_SEARCH_LIST_COMPONENT_KEY } from '../SavedSearchList.meta.js';

export default InjectedStyledComponent(Pill, SAVED_SEARCH_LIST_CATEGORY_KEY, SAVED_SEARCH_LIST_COMPONENT_KEY, [
	'notificationOn',
]);
